import { ProjectValidationCriteria } from "./projectvalidationcriteria";
import { ProjectApproval } from "./salesplan-vm";

export class GinfoProjectDetailsVm {
  projectTitle: string;
  pwrNumber: string;
  summary: string;
  sreSpoc: number;
  categoryId: number;
  projectId: number;
  headerId: number;
  orgId: number;
  vendorId?: number;
  type: string;
  changedBy: number;
  ctRequester?: number;
  ctRequesterName?: string | null;
  isProductManual?: boolean;
  isProductReviewConfirmed?: boolean;
  executionStart?: Date | null;
  executionEnd?: Date | null;
  numberOfStores?: number | null;
  scopeOfWork: string | null;
  marketingMaterials: boolean;
  shippingFrom: string;
  rmsNumber: string | null;
  shopCommItemNumber: string | null;
  dueToShippingFacility: any | null;
  dueToShippingFacilityst: string;
  selectedCategories : number[]=[];

  constructor() {
    this.projectTitle = '';
    this.pwrNumber = '';
    this.summary = '';
    this.sreSpoc = 0;
    this.categoryId = 0;
    this.projectId = 0;
    this.headerId = 0;
    this.orgId = 0;
    this.vendorId = 0;
    this.type = '';
    this.changedBy = 0;
    this.ctRequester = 0;
    this.ctRequesterName = null;
    this.isProductManual = false;
    this.isProductReviewConfirmed = false;
    this.executionStart = null;
    this.executionEnd = null;
    this.numberOfStores = null;
    this.scopeOfWork = null;
    this.marketingMaterials = false;
    this.shippingFrom = '';
    this.rmsNumber = '';
    this.shopCommItemNumber = '';
    this.dueToShippingFacility = null;
    this.dueToShippingFacilityst = '';
  }
}

export class ProjectFilesVm {
  projectFileID?: number;
  refID?: number;
  fileName?: string;
  purpose?: string;
  filePath?: string;
  createdBy?: number;
  createdDate?: Date;
  type?: string;
  fileChanged?: boolean;
  fileIndex?: number;
  base64Bytes?: string;
  rowsTotalCount?: number;
  storeNumbers?: string  
  //byteArray: Uint8Array;
  //file: File | null; 

  constructor() {
    this.projectFileID = 0;
    this.refID = 0;
    this.fileName = '';
    this.purpose = '';
    this.filePath = '';
    this.createdBy = 0;
    this.createdDate = new Date();
    this.type = '';
    this.fileChanged = false;
    this.fileIndex = -1;
    this.base64Bytes = "";
    this.rowsTotalCount = 0;
    this.storeNumbers = '';
    //this.byteArray = new Uint8Array();
    //this.file = null; 
  }
}

export class ProjectAttachmentFilesVm {
  projectFileID?: number;
  refID?: number;
  fileName?: string;
  purpose?: string;
  filePath?: string;
  createdBy?: number;
  createdDate?: Date;
  type?: string;
  fileChanged?: boolean;
  fileIndex?: number;
  base64Bytes?: string;
  rowsTotalCount?: number;
  //byteArray: Uint8Array;
  //file: File | null; 

  constructor() {
    this.projectFileID = 0;
    this.refID = 0;
    this.fileName = '';
    this.purpose = '';
    this.filePath = '';
    this.createdBy = 0;
    this.createdDate = new Date();
    this.type = '';
    this.fileChanged = false;
    this.fileIndex = -1;
    this.base64Bytes = "";
    this.rowsTotalCount = 0;
    //this.byteArray = new Uint8Array();
    //this.file = null; 
  }
}

export class GinfoKeyDatesVm {
  startDateStr?: string | null;
  endDateStr?: string | null;
  submittedDateStr?: string | null;
  leadTimeStr?: string | null;
  pwrDateStr?: string | null;
  approvedOnStr?: string | null;
  executionStartStr?: string | null;
  executionEndStr?: string | null;
  verificationStartStr?: string | null;
  verificationEndStr?: string | null;
  initiatedDateStr?: string | null;

  startDate?: Date | null;
  endDate?: Date | null;
  submittedDate?: Date | null;
  leadTime?: Date | null;
  pwrDate?: Date | null;
  approvedOn?: Date | null;
  executionStart?: Date | null;
  executionEnd?: Date | null;
  verificationStart?: Date | null;
  verificationEnd?: Date | null;
  isExecutionStart?: boolean;
  isExecutionComplete?: boolean;
  initiatedDate?: Date | null;

  constructor() {
    this.startDate = null;
    this.endDate = null;
    this.submittedDate = null;
    this.leadTime = null;
    this.pwrDate = null;
    this.approvedOn = null;
    this.executionStart = null;
    this.executionEnd = null;
    this.verificationStart = null;
    this.verificationEnd = null;
    this.isExecutionStart = false;
    this.isExecutionComplete = false;
    this.initiatedDate = null;
  }
}

export class GinfoObjectiveGoalsVm {
  objectiveId: number;

  constructor() {
    this.objectiveId = 0;
  }
}

export class ProjectGeneralInfoVm {
  projectDetails: GinfoProjectDetailsVm;
  storeList?: ProjectFilesVm | null;
  storeListManual?: ProjectFilesVm | null;
  isStoreManual?: boolean | null;
  keyDates: GinfoKeyDatesVm;
  objectiveGoals: GinfoObjectiveGoalsVm;
  materialRMS: GinfoObjectiveProjectRMSVm[];  
  isProductManual?: boolean;

  constructor() {
    this.projectDetails = new GinfoProjectDetailsVm();
    this.storeList = null;
    this.keyDates = new GinfoKeyDatesVm();
    this.objectiveGoals = new GinfoObjectiveGoalsVm();
    this.materialRMS = [];
    this.isProductManual = false;
    this.isStoreManual = false;
  }
}

export class ProjectVm {
    generalInfo: ProjectGeneralInfoVm;
    products?: ProjectFilesVm | null;
    productsManual: ProductListManualVm[] | null;
    projectCost: ProjectCost[] | [];
    projectStatus: ProjectStatus | null;
    projectStatuses: ProjectStatus[] | null;
    projectApproval: ProjectApproval | null;
    projectObjectives: ProjectObjective[] | [];
    projectMaterials: ProjectMaterial[] | [];
    projectAttachments: ProjectAttachement[] = [];
    projetAttachmentFiles: ProjectAttachmentFilesVm[] | [];
    projectActivities:  Activity[] =[];
    projectStatusMaster?: MasterStatusList[] | null;
    projectAgency: Agency | null;
    fundingAndRMSVM?: FundingAndRMS | null;
    instructionsVM?: InstructionsVM | null;   
    selectedCategories: number[] = []; 
    projectTemplateInstructions: ProjectTemplateInstructionsVm[] | [];
    projectValidationCriterias: ProjectValidationCriteria[] | [];
    productsReviewLog: ReviewLog[] | null;
    selectedStoresByStates: string | null; 
    identifiedStores: string | null;
    storesToIdentify: string | null;

  constructor() {
    this.generalInfo = new ProjectGeneralInfoVm();
    this.products = null;
    this.productsManual = null;
    this.projectCost = [];
    this.projectStatus = null;
    this.projectStatuses = [];
    this.projectApproval = null;
    this.projectObjectives = [];
    this.projectMaterials = [];
    this.projectAttachments = [];
    this.projetAttachmentFiles = [];
    this.projectActivities = [];
    this.projectStatusMaster = null;
    this.projectAgency = null;
    this.fundingAndRMSVM = null;
    this.instructionsVM = null;
    this.projectTemplateInstructions = [];
    this.projectValidationCriterias = [];
    this.productsReviewLog = null;
    this.selectedStoresByStates = null;
    this.identifiedStores = null;
    this.storesToIdentify = null;
  }
}

export class ProductListManualVm {
  installationProductID?: number;
  refID?: number;
  productID?: number;
  type?: string;
  product?: string | null;
  vendorItemNumber?: string;
  upc?: string;
  parentID?: number;
  productName?: string; 
  subProducts?: ProductListManualVm[];  
  isManuallyAddedNewProduct?:boolean;
  newProductID?:number;
  newProductTitle?:string;
  newProductParentTitle?:string;
  newProductParentID?:number;
  categoryID?:number;
  isItRemove?:boolean;
  isParentSelected?:boolean = true;
  transactionParentId?:number;



  constructor(
    installationProductID?: number,
    refID?: number,
    productID?: number,
    type?: string,
    product?: string,
    vendorItemNumber?: string,
    upc?: string,
    parentID?: number,
    productName?: string,
    subProducts?: ProductListManualVm[],    
    isManuallyAddedNewProduct?:boolean,
    newProductID?:number,
    newProductTitle?:string,
    newProductParentTitle?:string,
    newProductParentID?:number,
    categoryID?:number,
    isItRemove?:boolean

  ) {
    this.installationProductID = installationProductID;
    this.refID = refID;
    this.productID = productID;
    this.type = type;
    this.product = product,
    this.vendorItemNumber = vendorItemNumber
    this.upc = upc,
      this.parentID = parentID,
      this.productName=productName
      this.subProducts = [],      
      this.isManuallyAddedNewProduct=isManuallyAddedNewProduct,
      this.newProductID=newProductID,
      this.newProductTitle=newProductTitle,
      this.newProductParentTitle=newProductParentTitle,
      this.newProductParentID=newProductParentID,
      this.categoryID=categoryID,
      this.isItRemove=isItRemove
  }
}

export class Product {
  productID?: number;
  categoryID?: number;
  productTitle?: string;
  upc?: string;
  vendorItemNumber?: string;
  parentID?: number;
  isActive?: boolean;

  constructor(
    productID?: number,
    categoryID?: number,
    productTitle?: string,
    upc?: string,
    vendorItemNumber?: string,
    parentID?: number,
    isActive?: boolean
  ) {
    this.productID = productID;
    this.categoryID = categoryID;
    this.productTitle = productTitle;
    this.upc = upc;
    this.vendorItemNumber = vendorItemNumber;
    this.parentID = parentID;
    this.isActive = isActive;
  }
}


export class Agency {
  agencyID?: number;
  categoryID?: number;
  agencyName?: string;
  costPerHour?: number;
  agencyAddress1?: string;
  agencyAddress2?: string;
  isActive?: boolean;
  isDefault?: boolean;
  categoryAgencyID?: number;

  constructor(
    agencyID?: number,
    categoryID?: number,
    agencyName?: string,
    costPerHour?: number,
    agencyAddress1?: string,
    agencyAddress2?: string,
    isActive?: boolean,
    isDefault?: boolean
  ) {
    this.agencyID = agencyID;
    this.categoryID = categoryID;
    this.agencyName = agencyName;
    this.costPerHour = costPerHour;
    this.agencyAddress1 = agencyAddress1;
    this.agencyAddress2 = agencyAddress2;
    this.isActive = isActive;
    this.isDefault = isDefault;
  }
}

export class ProjectCost {
  projectCostID?: number;
  projectID?: number;
  agencyID?: number;
  numberOfStores?: number;
  numberOfHours?: string;
  costPerHour?: number;
  photoLinkCost?: string;
  hoursPerLocation?: number;
  costOfShippingStore?: number;
  estimatedTotalCost?: number;
  categoryAgencyID?: number;
  numberOfVisits?: number;
}

export class ProjectStatus {
  projectStatusID?: number;
  refID?: number;
  statusID?: number;
  type?: string;
  statusName?: string;
  changedBy?: number;
  changedDate?: Date;
  isApproved: boolean | undefined;

  constructor(projectStatusID?: number, refID?: number, statusID?: number,
    type?: string, statusName?: string, changedBy?: number, changedDate?: Date,
    isApproved?: boolean) {
    this.projectStatusID = projectStatusID;
    this.refID = refID;
    this.statusID = statusID;
    this.type = type;
    this.changedBy = changedBy;
    this.changedDate = changedDate;
    this.statusName = statusName;
    this.isApproved = isApproved;
  }
}
export class ProjectObjective {
  projectObjectiveID: number;
  projectID: number;
  objectiveID: number;

  constructor(objectiveId: any = 0) {
    this.projectObjectiveID = 0;
    this.projectID = 0;
    this.objectiveID = objectiveId;
  }
}

export class ProjectMaterial {
  projectMaterialID: number;
  projectID: number;
  materialID: number;
  materialDescriptionID: number;
  qtyPerStore: number | null;
  numberOfStores: number | null;
  materialDescription: string | null;
  article: string;
  constructor() {
    this.projectMaterialID = 0;
    this.projectID = 0;
    this.materialID = 0;
    this.qtyPerStore = null;
    this.numberOfStores = null;
    this.article = '';
    this.materialDescriptionID = 0;
    this.materialDescription = '';
  }
}
export class ProjectActivity {
  constructor(
    public id: number,
    public projectId: number,
    public activityID: number,
    public isChecked: boolean,
    public name: string
  ) { }
}

export class Activity {
  activityID: number;
  name: string;
  isChecked: boolean;
  constructor(activityID = 0, isChecked = false, name = "") {

    this.activityID = activityID;
    this.isChecked = isChecked;
    this.name = name;
  }
}
export class ProjectAttachement {
  attachmentID: number;
  projectID: number;
  description: string;
  storeORRep: string;
  printORView: string;
  pageCount: number | null;

  constructor() {
    this.attachmentID = 0;
    this.projectID = 0;
    this.description = "";
    this.storeORRep = "";
    this.printORView = "";
    this.pageCount = null
  }
}

export class MasterStatusList {
  statusID?: number;
  statusName?: string;

  constructor() {
    this.statusID = 0;
    this.statusName = '';
  }
}



export class fileBaseVM {
  base64Bytes?: string | null;
  fileChanged?: boolean;
  filename?: string | null;
  filePath?: string | null;
  isFileDeleted?: boolean | false;

  constructor() {
    this.base64Bytes = null;
    this.fileChanged = false;
    this.filename = null;
    this.filePath = null;
    this.isFileDeleted = false;
  }
}

export class FundingAndRMS extends fileBaseVM {
  fundingType?: number;
  sreReviewed?: boolean;
  reviewedBy?: number | null;
  reviewedByName?: string | null;
  cmfPromo?: string | null;
  cmfTactIcID?: string | null;
  estimatedCost?: number | null;
  emailJTBDFileName?: string | null;
  emailCategoryFileName?: string | null;
  jtbdReviewedBy?: number | null;
  // base64Bytes?: string | null;
  // fileChanged?: boolean;
  createdBy?: number | null;

  constructor() {
    super();
    this.fundingType = 0;
    this.sreReviewed = false;
    this.reviewedBy = null;
    this.reviewedByName = null;
    this.cmfPromo = null;
    this.cmfTactIcID = null;
    this.estimatedCost = null;
    this.emailJTBDFileName = null;
    this.emailCategoryFileName = null;
    this.jtbdReviewedBy = null;
    // this.base64Bytes = null;
    // this.fileChanged = false;
    this.createdBy = null;
  }
}

export class InstructionsVM{
  tools?: string | null;
  notes?: string | null;
  createdBy?: number | null;
  files: fileBaseVM[] | null;

  constructor() {
    //super();
    this.tools = null;
    this.notes = null;
    this.createdBy = null;
    this.files = null;
  }
}

export class GinfoObjectiveProjectRMSVm {
  materialRMSID: number;
  projectID: number | null;
  rmsNumber: string | null;
  status: string;

  constructor() {
    this.materialRMSID = 0;
    this.projectID = null;
    this.rmsNumber = null;
    this.status = "";
  }
}

export class ProjectTemplateInstructionsVm {
  projectTemplateID: number;
  refID: number;
  templateID: number;
  instructions: ProjectInstructionsVM[];

  constructor() {
    this.projectTemplateID = 0;
    this.refID = 0;
    this.templateID = 0;
    this.instructions = [];
  }
}

export class ProjectInstructionsVM {
  projectInstructionID: number;
  projectTemplateID: number;
  textID: number;
  text: string;
  images: InstructionImagesVm[];

  constructor() {
    this.projectInstructionID = 0;
    this.projectTemplateID = 0;
    this.textID = 0;
    this.text = '';
    this.images = [];
  }
}
export class InstructionImagesVm {
  imageID: number;
  image: string;
  base64Bytes: string;
  constructor() {
    this.imageID = 0;
    this.image = '';
    this.base64Bytes = '';
  }
}

export class InstallationProductResultDto {
  productDesc?: string;
  itemNumber?: string;
  upc?: string;
}

export class KeyDatesDto {
  headerId!: number;
  startDate?: Date;
  endDate?: Date;
  initiatedDate?: Date;
  startDateStr?: string | null;
  endDateStr?: string | null;
  initiatedDateStr?: string | null;
}

export class ReviewComments {
  commentID!: number;
  refID?: number;       // `?` denotes an optional property (equivalent to nullable in C#)
  type?: string;
  comment?: string;
  commentedBy?: string;
  actionDate?: Date;
}


export class Store {
  storeID?: number;
  vendorID?: number | null;
  storeNumber?: string | null;
  tdlinx?: string | null;
  storeName?: string | null;
  street?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  phone?: string | null;
  isActive?: boolean;
  status?: number;
}

export class InstallationStore {
  installationStoreID?: number;
  refID?: number | null;
  storeID?: number | null;
  type?: string | null;
}

export class StoreValidationVM {
  validInstallationStores?: InstallationStore[] | null;
  inActiveStores?: Store[] | null;
  inValidStores?: Store[] | null;
  ValidStoresnValidInstallationStores?: Store[] | null;
  validInstallationStoresForExcel?: Store[] | null;
  FileContent?: string;
  ContentType?: string;
  FileName?: string;
}

export class StoreValidationRequestVM{
  storeNubersList?: string | null;
}

export class ReviewLog {
  reviewID!: number;
  refID?: number;
  type?: string;
  reviewedFor?: string;
  reviewedBy?: string;
  reviewedOn?: Date;
}